import React, { Component, Fragment } from 'react'
import Avatar from '../Avatar'
import { ListItem, ListItemText } from 'material-ui/List'
import { Link } from 'react-router-dom'
import type { Councillor } from '../../types/Councillor'
import ProgressBar from '../ProgressBar'

const styles = {
  name: {
    display: 'inline-block',
    width: 'calc(100% - 60px)'
  },
  attendanceRate: {
    color: 'rgb(90, 90, 90)',
    fontSize: '16px',
    textAlign: 'right',
    verticalAlign: 'top'
  }
}

type Props = Councillor & {
  animate: boolean
}

class CouncillorListItem extends Component<Props> {
  render () {
    const {
      id,
      name,
      title,
      pictureUrl,
      attendanceRate,
      animate
    } = this.props

    const backgroundColor: string = attendanceRate < 60
      ? '#ffcccc'
      : attendanceRate < 90
        ? '#ffeb99'
        : '#adebad'

    return (
      <Fragment>
        <ProgressBar
          value={attendanceRate}
          backgroundColor={backgroundColor}
          className='absolute'
          animate={animate}
          height={68}
        />

        <ListItem button component={Link} to={`/toronto/councillors/${id}`}>
          <Avatar url={pictureUrl} />
          <ListItemText
            primary={
              <Fragment>
                <span style={styles.name}>{name}</span>
                <span style={styles.attendanceRate}>{attendanceRate}%</span>
              </Fragment>
            }
            secondary={title}
          />
        </ListItem>
      </Fragment>
    )
  }
}

export default CouncillorListItem



// WEBPACK FOOTER //
// ./src/components/CouncillorListItem/CouncillorListItem.js